import { render, staticRenderFns } from "./ChangeApplicationType.vue?vue&type=template&id=5c8ccecd&scoped=true"
import script from "./ChangeApplicationType.vue?vue&type=script&lang=ts"
export * from "./ChangeApplicationType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8ccecd",
  null
  
)

export default component.exports